import { combineReducers } from 'redux';
import authReducer from './authReducer';

/**
 * This is the main Reducer, in where we set all the
 * different reducers you'll need
 */
export default combineReducers({
  auth: authReducer,
});
